// chatBotState.ts
import { BehaviorSubject } from 'rxjs';

export class ChatBotState {


    private static chatMessagesState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

    static getChatMessagesState(): BehaviorSubject<any[]> {
        return this.chatMessagesState;
    }

    static setChatMessagesState(value: any[]): void {
        this.chatMessagesState.next(value);
    }
}
